"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncStatus = void 0;
var SyncStatus;
(function (SyncStatus) {
    SyncStatus["NOT_PROCESSING"] = "NOT_PROCESSING";
    SyncStatus["ERRORED"] = "ERRORED";
    SyncStatus["PROCESSING"] = "PROCESSING";
    SyncStatus["UP_TO_DATE"] = "UP_TO_DATE";
})(SyncStatus || (exports.SyncStatus = SyncStatus = {}));
